module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview",
    class: _vm.types
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": ("/portfolio/" + (_vm.project.slug))
    }
  }, [_c('div', {
    staticClass: "project-img",
    style: ({
      backgroundImage: ("url(" + _vm.imageSrc + ")")
    }),
    attrs: {
      "alt": _vm.project.alt
    }
  }, [_c('div', {
    staticClass: "overlay"
  }, [_c('h4', {
    staticClass: "project-name"
  }, [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('h4', {
    staticClass: "project-type"
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "role": "button"
    }
  }, [_vm._v("view project")])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36985dbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectPreview.vue
// module id = 584
// module chunks = 2